<wc-store-locator
  [title]="title"
  [posTypes]="posTypes"
  [posFeatures]="posFeatures"
  [isRepair]="true"
  [isCheckout]="false"
  [isEmbedded]="false"
  [hideCardActions]="false"
  [hideChooseButton]="true"
/>
